import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { FlexRow } from './FlexBox';
const HoverScale = (props) => {
    const { children, scale = 1.1 } = props;
    const useStyles = makeStyles(() => createStyles({
        zoomdiv: {
            '&:hover': {
                transform: `scale(${scale})`,
                transitionDuration: '0.2s',
                transitionTimingFunction: 'ease',
            },
        },
    }));
    const classes = useStyles();
    return (_jsx(FlexRow, { children: _jsx(Box, Object.assign({ className: classes.zoomdiv }, { children: children }), void 0) }, void 0));
};
export default HoverScale;
//# sourceMappingURL=HoverScale.js.map